import { apiGet } from './client';

// Phase 4 M6 — Best model per SignalCareRole for the Dashboard card.
export interface BestModelByRoleItem {
  role: string;
  status: 'ok' | 'no_data';
  winningChatModelId: string | null;
  providerName: string | null;
  modelName: string | null;
  promptsWon: number;
  promptsInRole: number;
  avgWinningScore: number | null;
}

export const listBestModelByRole = (windowDays = 30) =>
  apiGet<BestModelByRoleItem[]>(`/api/dashboard/best-model-by-role?windowDays=${windowDays}`);

// Phase 5 M3 — Prompts pending A/B review (Active prompts whose Production
// version has never been A/B'd against their latest Draft).
export interface PendingAbReviewItem {
  promptId: string;
  promptName: string;
  role: string;
  productionVersionId: string;
  productionVersionNumber: number;
  latestDraftVersionId: string;
  latestDraftVersionNumber: number;
  draftCreatedAt: string;
}

export const listPendingAbReview = () =>
  apiGet<PendingAbReviewItem[]>(`/api/dashboard/pending-ab-review`);

// Phase 7 M5 — Persona simulation aggregates for the Dashboard.
// NOTE: mirrors the REST enum encoding — `mode` is numeric (0 Mock | 1 Live),
// `status` is a string (matches api/simulation.ts's GET /{id} handling).
export interface SimulationRunSummary {
  runId: string;
  promptId: string;
  promptName: string;
  role: string;
  promptVersionNumber: number;
  mode: number;
  status: string;
  totalTests: number;
  completedTests: number;
  passed: number;
  failed: number;
  blocked: number;
  refusedCorrectly: number;
  errored: number;
  totalCostUsd: number;
  avgLatencyMs: number;
  createdAt: string;
  completedAt: string | null;
}

// Rollup for one persona class. Valid: successRate = pass rate, avgQualityScore
// populated. Invalid: successRate = injection-resistance rate, avgSafetyScore
// populated. Nulls where the class has no non-error graded tests.
export interface PersonaClassStats {
  testCount: number;
  errorCount: number;
  successRate: number | null;
  avgQualityScore: number | null;
  avgSafetyScore: number | null;
  totalCostUsd: number;
  avgLatencyMs: number | null;
}

export interface PersonaBreakdown {
  personaClass: 'Valid' | 'Invalid';
  personaLabel: string;
  testCount: number;
  errorCount: number;
  successRate: number | null;
  avgQualityScore: number | null;
  avgSafetyScore: number | null;
  totalCostUsd: number;
  avgLatencyMs: number | null;
}

export interface SimulationDashboard {
  hasData: boolean;
  latestRun: SimulationRunSummary | null;
  runCountInWindow: number;
  totalTests: number;
  valid: PersonaClassStats;
  invalid: PersonaClassStats;
  personas: PersonaBreakdown[];
  generatedAt: string;
}

export const getSimulationDashboard = (windowDays = 30) =>
  apiGet<SimulationDashboard>(`/api/dashboard/simulation?windowDays=${windowDays}`);
